'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:train:selectStation');
}

var _invoke = require('../invoke');

/**
 * 选择火车站
 *
 * TODO: 补全参数和返回值
 *
 * 支持版本
 * + iHotel/5.8+
 *
 * @memberof train
 * @static
 * @name selectStation
 * @param {String} stationCode 当前火车站
 * @param {String} stationType 类型
 * @return {Promise<station>}
 * @example
 *  hbnb.train.selectStation('code', 'type')
 *      .then(function(station) {
 *      });
 */
module.exports = function(stationCode, stationType) {
    if (process.env.NODE_ENV !== 'production') {
        debug('station code is %s', stationCode);
        debug('station type is %s', stationType);
    }

    var p = new Promise(function(resolve, reject) {
        _invoke('train', 'select_station', {
            stationCode: stationCode,
            stationType: stationType,
            callback: function(station) {
                resolve(station);
            }
        });
    });
    return p;
};



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@hfe/hbnb/train/select-station.js
// module id = 636
// module chunks = 0